import React, { useState } from 'react'
import './banner.scss'

import ModalVideo from '../../atoms/modal-video/modal-video'

import iconPlay from '../../../assets/images/icon-play.svg'

import iconMoon from '../../../assets/images/icon-moon.svg'
import { packShot, textChange } from '../../../constants/activity-constants'

const Banner = () => {
  const [showModalVideo, setShowModalVideo] = useState(false)

  return (
    <>
      <div className="f-banner">
        <div className="f-banner__stars" />

        <div className="f-banner__sectionMobile" />

        <div className="f-banner__infoCenter">
          <p>SISTEMA DE PROTECCIÓN</p>
          <span>360°</span>
        </div>

        <div className="f-banner__infobutton">
          <p>QUE SE MUEVE CONTIGO</p>
          <button
            onClick={() => {
              setShowModalVideo(true)
              try {
                window.dataLayer.push({
                  event: 'ga_event',
                  category: 'ui :: landing',
                  action: 'play video',
                  label: 'dale play y conocelas',
                  value: '',
                })
              } catch (error) {
                console.log(error)
              }
            }}
          >
            <img src={iconPlay} alt="icon-play" />
            Dale play y {textChange.text_2}
          </button>
        </div>

        <div className="f-banner__infoproduct">
          <div className="f-banner__infoproduct-title">
            <h1>
              {textChange.text_1}
              <img src={iconMoon} alt="tile-image" />
            </h1>
          </div>
          <p>MÁXIMA PROTECCIÓN </p>
          <div className={`f-banner__infoproduct-product ${process.env.LOCALE}`}>
            <img src={packShot} alt="product-image" />
          </div>
        </div>

        <a href="#beneficios" className="f-banner__buttonDown" />
      </div>

      {showModalVideo ? (
        <ModalVideo setShowModalVideo={setShowModalVideo} />
      ) : null}
    </>
  )
}

export default Banner
